import {useIntl} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {FormControl, Select} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import {ArrowIcon} from '../../../components/icons'
import {trackEvent} from '../../../tracking/analytics'

const Sort = ({sortUrls, productSearchResult, basePath, searchQuery, ...otherProps}) => {
    const intl = useIntl()
    const history = useHistory()
    const getSortingLabel = (index) => {
        return productSearchResult?.sortingOptions[index]?.label
    }

    return (
        <FormControl data-testid="sf-product-list-sort" id="page_sort" width="auto" {...otherProps}>
            <Select
                value={basePath.replace(/(offset)=(\d+)/i, '$1=0')}
                onChange={({target}) => {
                    trackEvent({
                        event: 'sort_by',
                        content_type: searchQuery ? 'search' : 'PLP',
                        filter_sort_by: getSortingLabel(target.selectedIndex)
                    })

                    history.push(target.value)
                }}
                height={11}
                width="100%"
                variant="link"
                aria-label={intl.formatMessage(
                    {
                        id: 'product_list.select.sort_by',
                        defaultMessage: 'Sort By: {sortOption}'
                    },
                    {
                        sortOption: ''
                    }
                )}
                icon={<ArrowIcon />}
            >
                {sortUrls.map((href, index) => (
                    <option key={href} value={href}>
                        {intl.formatMessage(
                            {
                                id: 'product_list.select.sort_by',
                                defaultMessage: 'Sort By: {sortOption}'
                            },
                            {
                                sortOption: getSortingLabel(index)
                            }
                        )}
                    </option>
                ))}
            </Select>
        </FormControl>
    )
}

Sort.propTypes = {
    sortUrls: PropTypes.array,
    productSearchResult: PropTypes.object,
    basePath: PropTypes.string,
    searchQuery: PropTypes.string
}

export default Sort
